export const StaticMenuDropDownData = [
  { label: 'Yes', value: '1' },
  { label: 'No', value: '2' },
];

export const EnvironmentDropDownData = [
  { label: 'Dev', value: 'https://api-dev.echosys.uk' },
  { label: 'Stage', value: 'https://api-stage.echosys.uk' },
  { label: 'Production', value: 'https://api.echosys.uk' },
  { label: 'LocalHost', value: 'http://localhost:5278' },
];

export const getGenericDefaultData = (): any => {
  const pageDomain = window.location.hostname;
  const defaultData = {
    staticMenu: StaticMenuDropDownData[1],
    environment: EnvironmentDropDownData[1],
  };
  if (pageDomain.search('localhost') > -1) {
    defaultData.staticMenu = StaticMenuDropDownData[0];
    defaultData.environment = EnvironmentDropDownData[0];
  }
  return defaultData;
};
